/* i18n/LanguagePicker.jsx — THE language selector, mounted in every app's
 * settings surface (V5 mandate: one settings framework, languages everywhere).
 * The list comes from the locale registry (data — a new language added at
 * runtime appears here with no code change), shows NATIVE names, persists via
 * the engine (lhc-locale) and retranslates the whole app instantly (Arabic
 * flips the document to RTL). Inherits the host's colors — works on light
 * store chrome, the dark technician OS and the fixed-look shells alike. */
import React from "react";
import { useI18n } from "./index";

export default function LanguagePicker({ compact = false, className, style }) {
  const { t, locale, setLocale, locales } = useI18n();
  return (
    <label className={className} data-lang-picker
      style={{ display: "inline-flex", alignItems: "center", gap: 8, ...(style || {}) }}>
      {!compact && <span style={{ fontSize: 12, opacity: 0.75 }}>{t("common.language")}</span>}
      <select
        value={locale}
        onChange={(e) => setLocale(e.target.value)}
        title={t("common.language")}
        style={{
          font: "inherit", fontSize: 13, padding: "4px 8px", borderRadius: 8,
          cursor: "pointer", background: "transparent", color: "inherit",
          border: "1px solid var(--border-strong, rgba(127,127,127,.35))",
        }}
      >
        {locales.map((l) => <option key={l.code} value={l.code}>{l.native}</option>)}
      </select>
    </label>
  );
}
